/**
 * Tracing utilities for generating and managing trace headers
 */

/**
 * Generate a UUID v4
 * @returns {string} UUID v4 string
 */
function generateUUID() {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
        const r = (Math.random() * 16) | 0;
        const v = c === 'x' ? r : (r & 0x3) | 0x8;
        return v.toString(16);
    });
}

/**
 * Generate trace headers for API requests
 * @returns {Object} Object containing trace-id and span-id headers
 */
export function generateTraceHeaders() {
    return {
        'trace-id': generateUUID(),
        'span-id': generateUUID(),
    };
}

/**
 * Get current trace context from an ongoing request
 * This can be expanded later for more complex tracing scenarios
 * @returns {Object|null} Current trace context or null
 */
export function getCurrentTraceContext() {
    // For now, we generate new trace context for each request
    // This can be enhanced later to support request correlation
    return null;
}

export default {
    generateTraceHeaders,
    getCurrentTraceContext,
};
